var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 32 32",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2C8.26 2 2 8.26 2 16C2 23.74 8.26 30 16 30C23.74 30 30 23.74 30 16C30 8.26 23.74 2 16 2ZM16 28C9.37 28 4 22.63 4 16C4 9.37 9.37 4 16 4C22.63 4 28 9.37 28 16C28 22.63 22.63 28 16 28Z",
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.07 15L8.93 15C7.61 15 7.61 17 8.93 17L23.07 17C24.39 17 24.39 15 23.07 15Z",
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinus);
export default __webpack_public_path__ + "static/media/Minus.4bfd6f90c3d9f6b687b62bae6eaf0e38.svg";
export { ForwardRef as ReactComponent };